import { render, staticRenderFns } from "./GridUpdated.vue?vue&type=template&id=31c21172&scoped=true&"
import script from "./GridUpdated.vue?vue&type=script&lang=js&"
export * from "./GridUpdated.vue?vue&type=script&lang=js&"
import style0 from "./GridUpdated.vue?vue&type=style&index=0&id=31c21172&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c21172",
  null
  
)

export default component.exports